import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Page } from '../components/Layout'
import { Aviso, Field, Money, TextInput } from '../components/ui'
import { setFunnel } from '../lib/funnel'

// Estimativa rápida ILUSTRATIVA (client-side). Encaminha para a triagem completa.
export default function Calculadora() {
  const nav = useNavigate()
  const [parcela, setParcela] = useState('')
  const [meses, setMeses] = useState('')

  const p = Number(parcela.replace(',', '.')) || 0
  const m = Number(meses) || 0
  const min = Math.round(p * m)
  const max = Math.round(p * m * 1.5)

  return (
    <Page>
      <h1 className="text-2xl font-semibold text-pfa-navy">Estimativa rápida</h1>
      <p className="mt-2 max-w-2xl text-pfa-slate">
        Uma ideia inicial e ilustrativa do valor de danos materiais. A avaliação real do seu caso é feita na triagem.
      </p>

      <div className="mt-6 grid gap-6 md:grid-cols-2">
        <div className="card">
          <Field label="Valor da parcela mensal (R$)">
            <TextInput inputMode="decimal" value={parcela} onChange={(e) => setParcela(e.target.value)} placeholder="Ex.: 2500" />
          </Field>
          <Field label="Meses de atraso (aproximado)">
            <TextInput inputMode="numeric" value={meses} onChange={(e) => setMeses(e.target.value)} placeholder="Ex.: 8" />
          </Field>
        </div>

        <div className="card flex flex-col justify-center">
          <p className="text-sm text-pfa-slate">Faixa ilustrativa de danos materiais</p>
          <p className="mt-2 text-2xl">
            <Money value={min} /> <span className="text-pfa-slate">a</span> <Money value={max} />
          </p>
          <p className="mt-3 text-xs text-pfa-slate/70">
            Proxy de lucros cessantes (parcela × meses). Não inclui eventuais danos morais nem multa contratual, que
            dependem da análise do contrato.
          </p>
        </div>
      </div>

      <div className="mt-6">
        <Aviso>
          Estimativa meramente ilustrativa. Não representa promessa, garantia ou previsão de resultado. O valor efetivo
          depende da análise jurídica do seu caso.
        </Aviso>
      </div>

      <button
        className="btn-accent mt-6"
        onClick={() => {
          setFunnel({ valor_parcela: p || undefined })
          nav('/triagem')
        }}
      >
        Avaliar meu caso de verdade
      </button>
    </Page>
  )
}
